import { useState } from 'react';
import { BookingPax, PaxTypeEnum } from '../../models/BookingData';
import './OccupationComponent.scss';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { useAppConfig } from '../../Contexts/AppConfigContext';
import { DownOutlined, TeamOutlined, UpOutlined } from '@ant-design/icons';

interface OccupationComponentProps {
    occupation: BookingPax[];
    checkOut: Date;
}

const OccupationComponent = (props: OccupationComponentProps): JSX.Element => {
    const appConfig = useAppConfig();
    const { t } = useTranslation();
    const { occupation, checkOut } = props;
    const [visible, setVisible] = useState<boolean>(false);

    const mapPaxType = (value: any): PaxTypeEnum => {
        switch (value) {
            case 0: return PaxTypeEnum.adult;
            case 1: return PaxTypeEnum.teenager;
            case 2: return PaxTypeEnum.child;
            case 3: return PaxTypeEnum.infant;
            default: return PaxTypeEnum.adult;
        }
    };

    const getPaxTypeMeta = (pax: BookingPax): { label: string; color: string } => {
        const type = mapPaxType(pax.paxType);
        switch (type) {
            case PaxTypeEnum.adult:
                return { label: t('pages.booking-detail.pax-type.adult'), color: 'occ-type--adult' };
            case PaxTypeEnum.teenager:
                return { label: `${t('pages.booking-detail.pax-type.teenager')} · ${pax.age}`, color: 'occ-type--teenager' };
            case PaxTypeEnum.child:
                return { label: `${t('pages.booking-detail.pax-type.child')} · ${pax.age}`, color: 'occ-type--child' };
            case PaxTypeEnum.infant:
                return { label: `${t('pages.booking-detail.pax-type.infant')} · ${pax.age}`, color: 'occ-type--infant' };
            default:
                return { label: String(pax.paxType), color: 'occ-type--adult' };
        }
    };

    return (
        <div className="occupation-component">
            <button type="button" className="occ-toggle" onClick={() => setVisible(v => !v)}>
                <span className="occ-toggle-label">
                    <TeamOutlined className="occ-icon" />
                    {t('pages.booking-detail.occupation')}
                    <span className="occ-count">{occupation.length}</span>
                </span>
                {visible ? <UpOutlined className="occ-chevron" /> : <DownOutlined className="occ-chevron" />}
            </button>

            {visible && (
                <div className="occ-list">
                    {occupation.map((pax: BookingPax, index: number) => {
                        const { label, color } = getPaxTypeMeta(pax);
                        return (
                            <div key={index} className="occ-row">
                                <span className="occ-index">{index + 1}</span>
                                <span className="occ-name">
                                    {pax.name} {pax.surname} {pax.secondSurname ?? ''}
                                </span>
                                <span className={`occ-type-badge ${color}`}>{label}</span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default OccupationComponent;
